import React from 'react';
import emojiRegex from 'emoji-regex/RGI_Emoji';

export function getEmojiFormattedSpan(label) {
  return label.replace(
    emojiRegex(),
    (emoji) => `<span class="emoji-text">${emoji}</span>`,
  );
}

export function ScaleSteps({ min, max, step }) {
  const steps = [];
  for (let i = min; i <= max; i += step) {
    steps.push(
      <span key={i} className={`scale-step scale-step--${i}`}>
        |
      </span>,
    );
  }
  return steps;
}

export function ScaleLabels({ sliderItems = [] }) {
  const labels = [];
  sliderItems.forEach(({ tickValue, tickLabel }) => {
    labels.push(
      <span
        key={tickValue}
        className={`scale-label scale-label--${tickValue}`}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: getEmojiFormattedSpan(tickLabel) }}
      />,
    );
  });
  return labels;
}
